import { showFailureToast, showSuccessToast } from "@helpers";
import { createAction, createSlice } from "@reduxjs/toolkit";

const deleteItemFromCartSlice = createSlice({
  name: "deleteItemFromCart",
  initialState: { data: null, processing: false },
  reducers: {
    pending(state, action) {
      state.processing = true;
      /* TODO: reducer for pending*/
    },
    success(state, action) {
      state.processing = false;
      showSuccessToast("Delete item successful!");
      /* TODO: reducer for success*/
    },
    failure(state, action) {
      state.processing = false;
      showFailureToast("Delete item failure!");
      /* TODO: reducer for failure*/
    },
  },
});

const { name, actions, reducer } = deleteItemFromCartSlice;
const deleteItemFromCartAction = createAction(name);

export {
  deleteItemFromCartAction,
  actions as deleteItemFromCartActions,
  reducer as deleteItemFromCartReducer,
};
